import { useEffect, useRef, useState } from "react";

function AudioPlayer({ audioUrl }) {
  const audioRef = useRef(null);
  const progressRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0); // value from 0 to 100

  // Toggle Play / Pause
  const togglePlayPause = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  // Update progress bar as audio plays
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const updateProgress = () => {
      const percentage = (audio.currentTime / audio.duration) * 100;
      setProgress(percentage);
    };

    audio.addEventListener("timeupdate", updateProgress);

    return () => {
      audio.removeEventListener("timeupdate", updateProgress);
    };
  }, []);

  if (!audioUrl || (Array.isArray(audioUrl) && audioUrl.length === 0)) {
    return <div></div>;
  }

  // Seek when user clicks on progress bar
  const handleProgressClick = (e) => {
    const audio = audioRef.current;
    const rect = progressRef.current.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const width = rect.width;
    const newTime = (clickX / width) * audio.duration;
    audio.currentTime = newTime;
  };

  return (
    <div
      style={{
        width: "400px",
        padding: "10px",
        backgroundColor: "#f2f2f2",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <audio ref={audioRef} src={audioUrl} preload="metadata" />

      <button
        onClick={togglePlayPause}
        style={{
          border: "none",
          background: "none",
          fontSize: "20px",
          cursor: "pointer",
        }}
      >
        {isPlaying ? "⏸️" : "▶️"}
      </button>

      <div
        ref={progressRef}
        onClick={handleProgressClick}
        style={{
          flexGrow: 1,
          height: "6px",
          backgroundColor: "#ddd",
          borderRadius: "3px",
          position: "relative",
          cursor: "pointer",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${progress}%`,
            backgroundColor: "#4caf50",
            borderRadius: "3px",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: "-5px",
            left: `calc(${progress}% - 5px)`,
            width: "14px",
            height: "14px",
            backgroundColor: "#4caf50",
            borderRadius: "50%",
            pointerEvents: "none",
          }}
        ></div>
      </div>
    </div>
  );
}

export default AudioPlayer;
